import React, { useEffect, useState } from "react";
import gsap from "gsap";

export default function LoadingPage() {
  const [showLoadingPage, setShowLoadingPage] = useState(true);

  useEffect(() => {
    gsap.fromTo(
      ".loading-page",
      { opacity: 1 },
      {
        opacity: 0,
        display: "none",
        duration: 6,
        delay: 4, // Time the wave animation runs before hiding the loading page
        onComplete: () => setShowLoadingPage(false),
      }
    );
  }, []);

  if (!showLoadingPage) {
    return null;
  }

  return (
<div className="loading-page fixed inset-0 z-50 flex justify-center items-center bg-black text-white">
  <div className="name-container">
    <div className="logo-name wave-text">KAYDEETECH</div>
  </div>

  <style jsx>{`
    .loading-page {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 50;
      background-color: black;
    }

    .name-container {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
    }

    .wave-text {
      display: inline-block;
      font-size: .7rem;
      color: transparent;
      background: linear-gradient(to right, orange, orange 50%, transparent 50%);
      background-size: 200% 100%;
      -webkit-background-clip: text;
      background-clip: text;
      animation: wave 2s linear infinite;
      line-height: 1;
    }

    @keyframes wave {
      0% {
        background-position: 200% 0;
      }
      50% {
        background-position: 0 0;
      }
      100% {
        background-position: -200% 0;
      }
    }
  `}</style>
</div>

  );
}
